import { styled } from '@linaria/react';
import { Flex } from '@daedalus/atlas/helpers/Flex';
export const MODAL_WIDTH = 522;
export const BEST_DEAL_IMAGE_HEIGHT = 180;
const _exp = /*#__PURE__*/() => Flex.Row;
export const HeaderElement = /*#__PURE__*/styled(_exp())({
  name: "HeaderElement",
  class: "h3drwh2",
  propsAsIs: true
});
const _exp3 = /*#__PURE__*/() => Flex.Row;
export const ExitPopupHeaderContentWrapper = /*#__PURE__*/styled(_exp3())({
  name: "ExitPopupHeaderContentWrapper",
  class: "ej041kv",
  propsAsIs: true
});
export const AlarmIconWrapper = /*#__PURE__*/styled('span')({
  name: "AlarmIconWrapper",
  class: "a17nnzva",
  propsAsIs: false
});
export const PopupOfferContainer = /*#__PURE__*/styled('div')({
  name: "PopupOfferContainer",
  class: "p1vlkufe",
  propsAsIs: false
});
export const PopupOffersContainer = /*#__PURE__*/styled('div')({
  name: "PopupOffersContainer",
  class: "p1jpg2yl",
  propsAsIs: false
});
export const ExitPopupContentWrapper = /*#__PURE__*/styled('div')({
  name: "ExitPopupContentWrapper",
  class: "e19b9g07",
  propsAsIs: false
});
export const StarRatingWrapper = /*#__PURE__*/styled('div')({
  name: "StarRatingWrapper",
  class: "sja9vge",
  propsAsIs: false
});
export const HotelName = /*#__PURE__*/styled('div')({
  name: "HotelName",
  class: "htkcj0w",
  propsAsIs: false
});
export const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "i9yh4ou",
  propsAsIs: false
});
export const ContentDetailsWrapper = /*#__PURE__*/styled('div')({
  name: "ContentDetailsWrapper",
  class: "c121j8h4",
  propsAsIs: false
});
const _exp18 = /*#__PURE__*/() => Flex.Row;
export const RatingLoadingWrapper = /*#__PURE__*/styled(_exp18())({
  name: "RatingLoadingWrapper",
  class: "r1555x0r",
  propsAsIs: true
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");